/** @format — Shared typing indicator (tracking + shipment chat) */

import React from "react";
import TypingDots from "./TypingDots";

export default function TrackingTypingBubble() {
  return (
    <div className="inline-flex items-center px-3.5 py-2.5 rounded-[20px] bg-[#E8F0FE]">
      <TypingDots dotClassName="bg-[#64748B]" sizeClass="h-1.5 w-1.5" />
    </div>
  );
}
